'use strict';

export default function f($window) {
  'ngInject';

  return {
    track(event, data) {
      if (typeof gtag !== 'undefined') {
        let category = (data && data['category']) ? data['category'] : null;
        let label = (data && data['label']) ? data['label'] : null;
        let value = (data && data['value']) ? data['value'] : null;
        let gtagData = {
          event_category: category,
          event_label: label,
          value: value
        };
        gtag('event', event, gtagData);
      }
    },
    pageview(url) {
      if (typeof gtag !== 'undefined') {
        gtag('event', 'page_view');
      }
    },
    identify(userId) {
      if (typeof gtag !== 'undefined') {
        gtag('set', {'user_id': userId});
      }
    },
    reset() {
      if (typeof gtag !== 'undefined') {
        gtag('set', {'user_id': null});
      }
    },
  };
}



// WEBPACK FOOTER //
// ./app/src/services/analytics.js